import React, { Fragment, useEffect, useState } from "react";
import { AiFillDelete } from "react-icons/ai";
import { AiFillEdit } from "react-icons/ai";
import { apiJson } from "../../../api/Api";
import { toast } from "react-toastify";
import Header from "../subheader/Header";
import { Link, useLocation } from "react-router-dom";
import "./menu.scss";

const EditMenuItem = (props) => {
  const [menu_items, setMenuItems] = useState([]);
  const [categories, setCategories] = useState([]);

  const [name_en, setNameEn] = useState("");
  const [name_en_error, setNameEnError] = useState("");
  const [name_ar, setNameAr] = useState("");
  const [position, setPosition] = useState();
  const [parent_id, setParentId] = useState(0);
  const [link, setLink] = useState("");
  const [link_error, setLinkError] = useState("");

  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const showSuccess = () => {
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    document.title = "Add Menu";

    apiJson.store.getMenuItem(props.match.params.id).then((response) => {
      if (response.success) {
        setNameEn(response.data.name_en);
        setNameAr(response.data.name_ar);
        setPosition(response.data.position);
        setParentId(response.data.parent_id);
        setLink(response.data.link);
      } else if (!response.status) {
        // eslint-disable-next-line
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
              ? response.errors
              : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });

    apiJson.store.getMenu().then((response) => {
      if (response.success) {
        setMenuItems(response.data.menu_items);
      } else if (!response.status) {
        // eslint-disable-next-line
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
              ? response.errors
              : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });

    apiJson.categories.getCategorieForProductServices().then((response) => {
      if (response.success) {
        setCategories(response.data);
      } else if (!response.status) {
        // eslint-disable-next-line
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
              ? response.errors
              : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
  }, []);

  const handleValidation = () => {
    var isValid = true;

    if (!name_en) {
      setNameEnError("*English name is required.");
      isValid = false;
    }
    else {
      setNameEnError("");
    }

    if (!link) {
      setLinkError("*Link is required.");
      isValid = false;
    }
    else {
      if (link.startsWith("/")) {
        setLinkError("*Link should not start with '/'");
        isValid = false;
      }
      else {
        setLinkError("");
      }
    }

    return isValid;
  }

  const onFormSubmit = (e) => {
    e.preventDefault();

    if (handleValidation()) {
      apiJson.store.editMenuItem(props.match.params.id, {
        menu_item: {
          name_en: name_en,
          name_ar: name_ar,
          position: position,
          parent_id: parent_id,
          link: link
        }
      }, props.match.params.id)
        .then(response => {
          if (response.success) {
            message = "Menu item updated successfully.";
            showSuccess();
            props.history.push("/vendor/menu");
          }
          else {
            message = response.message;
            showSuccess();
          }
        })
    }
  }

  return (
    <Fragment>
      <div className="vendor-page-right profile-page-desktop">
        <Header heading="Menu Items" search={false} filters={null} />
        <div className="right-content profile-page-content">
          <div className="content-container profile-page-container">
            <div className="content-wrapper menu">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={(e) => onFormSubmit(e)}>
                    <div className="form-group">
                      <label>Name (English)</label>
                      <input type="text" name="name_en" value={name_en} onChange={(e) => setNameEn(e.target.value)} className="form-control" />
                      <p className="text-danger m-0">{name_en_error}</p>
                    </div>
                    <br />
                    <div className="form-group">
                      <label>Name (Arabic)</label>
                      <input type="text" name="name_ar" value={name_ar} onChange={(e) => setNameAr(e.target.value)} className="form-control" />
                    </div>
                    <br />
                    <div className="form-group">
                      <label>Position</label>
                      <input type="number" name="position" value={position} onChange={(e) => setPosition(e.target.value)} className="form-control" />
                    </div>
                    <br />
                    <div className="form-group">
                      <label>Parent</label>
                      <select name="parent" className="form-control" value={parent_id} onChange={(e) => setParentId(e.target.value)}>
                        <option value="0">--- Select Parent ---</option>
                        {
                          menu_items?.map(menu_item => {
                            return (
                              <option value={menu_item.id}>{menu_item.name_en}</option>
                            )
                          })
                        }
                      </select>
                    </div>
                    <br />
                    <label>Link</label>
                    <div className="input-group">
                      <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon2">https://alisuq.com/</span>
                      </div>
                      <input name="link" type="text" value={link} onChange={(e) => setLink(e.target.value)} className="form-control" />
                    </div>
                    <p className="text-danger m-0">{link_error}</p>
                    <br />
                    <input type="submit" className="btn w-100 btn-primary" value="SAVE" />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EditMenuItem;
